import React, { ReactChild, useCallback } from 'react';
import ReactGA4 from 'react-ga4';
import { useSwitch, useUserType } from '@/hooks';
import { I18nSwitchModal } from '@/components/DesktopHeader/I18nSwitch';

export const I18nSwitch = ({ children }: { children?: ReactChild }) => {
  const userType = useUserType();
  const { on, turnOn, turnOff } = useSwitch();

  const handleIconClick = useCallback(() => {
    ReactGA4.event({
      category: 'AI Language',
      action: `Click_Language_Icon_${userType}`,
    });
    turnOn();
  }, [turnOn, userType]);

  // const localeLable = useMemo(
  //   () => SUPPORTED_LOCALES.find(x => x.key === currentLocale)?.abbr,
  //   [currentLocale],
  // );

  return (
    <>
      {React.isValidElement(children)
        ? React.cloneElement(children, {
            onClick: handleIconClick,
          } as any)
        : null}
      {on ? <I18nSwitchModal turnOff={turnOff} /> : null}
    </>
  );
};
